<template>
  <div id="app">
    <div id="content" class="addedit-person">
      <!-- HEADER -->
      <Header
        :page="'participant_edit'"
        :title_one="'participant'"
        :action_one="'update'"
        :action_two="'cancel'"
        @update="validate()"
        :banner_docsok_msg="doc_ok"
      ></Header>

      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <div class="box">
            <h6 class="form-subtitle">{{ $t("titles.player_nike") }}</h6>

            <!-- NAME -->
            <div class="item">
              <label
                >{{ $t("params.name") }} <span class="obligatory">*</span>
              </label>
              <input
                v-bind:class="error.name ? 'input-error' : ''"
                type="text"
                v-model="input.name"
                class="upper"
                autocomplete="new-text"
                disabled
              />
            </div>

            <!-- SURNAME -->
            <div class="item">
              <label
                >{{ $t("params.surname") }} <span class="obligatory">*</span>
              </label>
              <input
                v-bind:class="error.surname ? 'input-error' : ''"
                type="text"
                v-model="input.surname"
                class="upper"
                autocomplete="new-text"
                disabled
              />
            </div>

            <!-- DNI -->
            <div class="item">
              <label
                >{{
                  $t("params.dni") +
                  " / " +
                  $t("params.nie") +
                  " / " +
                  $t("params.passport")
                }}
                <span class="obligatory">*</span>
                <span class="obligatory error" v-if="error.invalit_dni">{{
                  " " + $t("errors.invalit_dni")
                }}</span>
                <span class="obligatory error" v-if="error.invalit_nie">{{
                  " " + $t("errors.invalit_nie")
                }}</span>
                <span class="obligatory error" v-if="error.duplicated_dni">{{
                  " " + $t("errors.duplicated_dni")
                }}</span>
              </label>
              <div>
                <v-radio-group v-model="input.document_type" row disabled>
                  <v-radio :label="$t('params.dni')" value="1"></v-radio>
                  <v-radio :label="$t('params.nie')" value="2"></v-radio>
                  <v-radio :label="$t('params.passport')" value="3"></v-radio>
                </v-radio-group>
                <input
                  v-if="input.document_type == '1'"
                  v-bind:class="error.dni ? 'input-error' : ''"
                  type="text"
                  v-model="input.dni"
                  :placeholder="
                    $t('params.dni') + '  ' + $t('params.dni_format')
                  "
                  ref="dni"
                  class="upper"
                  autocomplete="new-text"
                  disabled
                />
                <input
                  v-if="input.document_type == '2'"
                  v-bind:class="error.dni ? 'input-error' : ''"
                  type="text"
                  v-model="input.dni"
                  :placeholder="
                    $t('params.nie') + '  ' + $t('params.nie_format')
                  "
                  ref="dni"
                  class="upper"
                  autocomplete="new-text"
                  disabled
                />
                <input
                  v-if="input.document_type == '3'"
                  v-bind:class="error.dni ? 'input-error' : ''"
                  type="text"
                  v-model="input.dni"
                  :placeholder="$t('params.passport')"
                  ref="dni"
                  class="upper"
                  autocomplete="new-text"
                  disabled
                />
              </div>
            </div>

            <!-- BIRTHDAY -->
            <div class="item" id="birthday">
              <label
                >{{ $t("params.birthday") }} <span class="obligatory">*</span>
                <span class="obligatory" v-if="error.invalit_birthday">
                  {{ $t("errors.birthday_campus", { a: 8, b: 17 }) }}</span
                ></label
              >
              <!-- <v-menu
                  v-model="dialog_birthday"
                  autocomplete="new-text"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      prepend-icon="event"
                      v-model="input.parsedBirthday"
                      @click:prepend="dialog_birthday = true"
                      :placeholder="'DD/MM/YYYY'"
                      :class="error.birthday ? 'error' : ''"
                      disabled
                  ></v-text-field>
                </template>
                <v-date-picker v-model="input.birthday" @input="dialog_birthday = false, formatBirthday()"></v-date-picker>
              </v-menu> -->
              <input disabled v-model="input.parsedBirthday" />
            </div>

            <!-- GENDER -->
            <div class="item">
              <label>{{ $t("params.gender") }}</label>
              <v-radio-group v-model="input.gender" row disabled>
                <v-radio :label="$t('gender.male')" value="1"></v-radio>
                <v-radio :label="$t('gender.female')" value="2"></v-radio>
                <!-- <v-radio :label="$t('gender.other')" value="3"></v-radio> -->
              </v-radio-group>
            </div>

            <!-- COUNTRY -->
            <div class="item" id="country">
              <label>{{ $t("params.country") }}</label>
              <v-autocomplete
                :class="error.country ? 'input-error' : ''"
                v-model="input.country_id"
                :items="Object.values(countries)"
                item-text="name"
                item-value="id"
                no-data
                hide-no-data
                :browser-autocomplete="'asd2saS<'"
              >
              </v-autocomplete>
            </div>

            <!-- ADDRESS -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("params.address") }}</label>
              <input
                type="text"
                v-model="input.address"
                autocomplete="new-text"
              />
            </div>

            <!-- CP -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("params.cp") }}</label>
              <input type="text" v-model="input.cp" autocomplete="new-text" />
            </div>

            <!-- CITY -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("params.city") }}</label>
              <input type="text" v-model="input.city" autocomplete="new-text" />
            </div>

            <!-- STATE -->
            <div class="item">
              <label>{{ $t("params.state") }}</label>
              <input
                type="text"
                v-model="input.state"
                autocomplete="new-text"
              />
            </div>

            <!-- PHONE -->
            <div class="item">
              <label
                >{{ $t("params.phone") }} <span class="obligatory">*</span>
                <span v-if="error.invalit_phone" class="obligatory">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <vue-tel-input
                v-model="input.phone"
                @input="playerPhone"
                autocomplete="new-text"
                style="border-color: transparent"
                :placeholder="''"
                :class="error.invalit_phone ? 'input-error' : ''"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
              ></vue-tel-input>
            </div>

            <!-- MOBILE -->
            <div class="item" v-if="!is_virtual">
              <label
                >{{ $t("params.phone2") }} <span class="obligatory">*</span>
                <span v-if="error.invalit_mobile" class="obligatory">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <vue-tel-input
                v-model="input.mobile"
                @input="playerMobile"
                autocomplete="new-text"
                style="border-color: transparent"
                :placeholder="''"
                :class="error.invalit_mobile ? 'input-error' : ''"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
              ></vue-tel-input>
            </div>

            <!-- EMAIL -->
            <div class="item">
              <label>{{ $t("params.email") }}</label>
              <input
                type="email"
                v-model="input.email"
                autocomplete="new-text"
                disabled
              />
            </div>

            <!-- MEDICAMENTO -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("params.medicamento") }}</label>
              <input
                type="text"
                v-model="input.medicamento"
                autocomplete="new-text"
              />
            </div>

            <!-- ALERGY -->
            <div class="item" id="alergy" v-if="!is_virtual">
              <label>{{ $t("params.alergy") }}</label>
              <v-select
                :class="error.alergy ? 'error' : ''"
                v-model="input.alergy"
                :items="Object.values(alergies)"
                item-text="name"
                item-value="id"
                multiple
                :browser-autocomplete="'asd2saS<'"
                ref="alergy"
                id="alergies"
                style="padding: 0"
                attach
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    close
                    @input="removeAlergy(data.item)"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
              </v-select>
            </div>

            <!-- OTHER ALLERGIES  -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("params.other_allergies") }}</label>
              <input
                type="text"
                v-model="input.other_allergies"
                autocomplete="new-text"
              />
            </div>

            <!-- DIET -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("params.diet") }}</label>
              <select v-model="input.diet">
                <option v-for="(value, key) in diets" :key="key" :value="key">
                  {{ $t(value.name) }}
                </option>
              </select>
            </div>

            <!-- SWIM -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("swim") }}</label>
              <v-radio-group v-model="input.swim" row>
                <v-radio :label="$t('si')" value="1"></v-radio>
                <v-radio :label="$t('no')" value="0"></v-radio>
              </v-radio-group>
            </div>

            <!-- (NIKE) HEIGHT -->
            <div class="item" v-if="input.altura != null && !is_virtual">
              <label>{{ $t("params.altura") }}</label>
              <input
                type="number"
                v-model="input.altura"
                :placeholder="$t('params.altura')"
                @keypress="onlyNumber"
              />
            </div>

            <!-- (PGA) JOIN TO PGA -->
            <!-- <div class="item" v-if="input.join_campus != null">
                        <label>{{$t('params.join_campus')}}</label>
                        <select v-model="input.join_campus">
                          <option v-for="(value, key) in joinCampus" :value="key" :key="key">
                            {{ $t('campus.' + value.name) }}
                          </option>
                        </select>
                      </div> -->

            <!-- (PGA) Clothing size -->
            <div class="item" v-if="input.shirt_size != null && !is_virtual">
              <label
                >{{ $t("campus.size") }}
                <span
                  ><a :href="clothing_size_link" target="_blank"
                    >({{ $t("descriptions.clothing_size") }})</a
                  ></span
                >
              </label>
              <select v-model="input.shirt_size" disabled>
                <option
                  v-for="(value, key) in shirt_sizes"
                  :value="key"
                  :key="key"
                >
                  {{ $t("campus." + value.name) }}
                </option>
              </select>
            </div>

            <!-- (PGA) Club Name -->
            <div class="item" v-if="input.club_name != null && !is_virtual">
              <label> {{ $t("campus.club_name") }} </label>
              <input
                class="upper"
                type="text"
                v-model="input.club_name"
                autocomplete="new-text"
              />
            </div>

            <!-- (NIKE) GoalKeeper -->
            <div class="item" v-if="input.goalkeeper != null">
              <label>{{ $t("params.field_position") }}</label>
              <select v-model="input.goalkeeper">
                <option value="0">
                  {{ $t("params.field_player") }}
                </option>
                <option value="1">
                  {{ $t("params.goalkeeper") }}
                </option>
              </select>
            </div>

            <!-- HOW MEET -->
            <!-- <div class="item">
                        <label>{{$t('params.how_meet')}}</label>
                        <select v-model="input.how_meet">
                            <option v-for="type in how_meet" v-bind:value="type.id" v-bind:key="type.id">
                              {{$t(type.name)}}
                            </option>
                        </select>
                      </div> -->

            <!-- LANG -->
            <div class="item">
              <label>{{ $t("params.communication") }} </label>
              <v-radio-group
                v-model="input.language"
                row
                autocomplete="new-text"
              >
                <v-radio
                  v-for="language in languages"
                  v-bind:value="language.id"
                  v-bind:key="language.id"
                >
                  <template v-slot:label>
                    <span> {{ language.name }} </span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>

            <!-- LOTTERY -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("params.lottery") }}</label>
              <v-checkbox
                v-model="input.lottery"
                :disabled="input.lottery_send == 1"
              >
                <template v-slot:label>
                  <span
                    v-if="user.event_name.includes('MICCamp')"
                    v-html="$t('descriptions.lottery', { s: lottery_link })"
                  ></span>
                  <span
                    v-if="user.event_name == 'Pau Gasol Academy'"
                    v-html="$t('campus.lottery', { s: lottery_link })"
                  ></span>
                </template>
              </v-checkbox>
            </div>

            <template v-if="event.type_id == 4">
              <h6 class="form-subtitle">{{ $t("titles.transport") }}</h6>

              <div class="item">
                <label
                  >{{ $t("descriptions.nike_bus_type") }}
                  <span class="obligatory">*</span>
                </label>
                <select
                  class="shadow"
                  v-bind:class="error.bus ? 'error' : ''"
                  v-model="input.bus"
                  :disabled="true"
                >
                  <option
                    v-for="type in bus_options"
                    v-bind:value="type.id"
                    v-bind:key="type.id"
                  >
                    {{ $t(type.name) }}
                  </option>
                </select>
              </div>
              <template v-if="[1, 3].includes(parseInt(input.bus))">
                <div class="item">
                  <label
                    >{{ $t("titles.external") }}
                    <span class="obligatory">*</span>
                  </label>
                  <label v-if="[2, 3].includes(parseInt(input.pickup))">
                    <span class="info"
                      >{{
                        $t(
                          parseInt(input.pickup) == 2
                            ? "campus.pickup.bcnsants_description"
                            : "campus.pickup.bcnairport_description"
                        )
                      }}
                    </span>
                  </label>
                  <select
                    class="shadow"
                    v-bind:class="error.pickup ? 'error' : ''"
                    v-model="input.pickup"
                    @change="refresh"
                  >
                    <option
                      v-for="type in pickup_options"
                      v-bind:value="type.id"
                      v-bind:key="type.id"
                    >
                      {{ $t(type.name) }}
                    </option>
                  </select>
                </div>
                <template v-if="[2, 3].includes(parseInt(input.pickup))">
                  <div class="item">
                    <label
                      >{{ $t("params.travel_number") }}
                      <span class="obligatory">*</span>
                    </label>
                    <input
                      v-bind:class="error.transport_number ? 'input-error' : ''"
                      type="text"
                      v-model="input.transport_number"
                      class="upper"
                      autocomplete="new-text"
                    />
                  </div>
                  <div class="item">
                    <label
                      >{{ $t("params.travel_from") }}
                      <span class="obligatory">*</span>
                    </label>
                    <input
                      v-bind:class="error.transport_from ? 'input-error' : ''"
                      type="text"
                      v-model="input.transport_from"
                      class="upper"
                      autocomplete="new-text"
                    />
                  </div>
                </template>
              </template>
              <template v-if="[2, 3].includes(parseInt(input.bus))">
                <div class="item">
                  <label
                    >{{ $t("titles.returnit") }}
                    <span class="obligatory">*</span>
                  </label>
                  <label v-if="[2, 3].includes(parseInt(input.returnit))">
                    <span class="info"
                      >{{
                        $t(
                          parseInt(input.returnit) == 2
                            ? "campus.returnit.bcnsants_description"
                            : "campus.returnit.bcnairport_description"
                        )
                      }}
                    </span>
                  </label>
                  <select
                    class="shadow"
                    v-bind:class="error.returnit ? 'error' : ''"
                    v-model="input.returnit"
                    @change="refresh"
                  >
                    <option
                      v-for="type in pickup_options"
                      v-bind:value="type.id"
                      v-bind:key="type.id"
                    >
                      {{ $t(type.name) }}
                    </option>
                  </select>
                </div>
                <!-- <template v-if="[2, 3].includes(parseInt(input.pickup))">
                    <div class="item">
                    <label
                        >{{ $t("params.travel_number") }}
                        <span class="obligatory">*</span>
                    </label>
                    <input
                        v-bind:class="error.transport_number ? 'input-error' : ''"
                        type="text"
                        v-model="input.transport_number"
                        class="upper"
                        autocomplete="new-text"
                    />
                    </div>
                    <div class="item">
                    <label
                        >{{ $t("params.travel_from") }}
                        <span class="obligatory">*</span>
                    </label>
                    <input
                        v-bind:class="error.transport_from ? 'input-error' : ''"
                        type="text"
                        v-model="input.transport_from"
                        class="upper"
                        autocomplete="new-text"
                    />
                    </div>
                </template> -->
              </template>
            </template>

            <template v-if="!is_virtual">
              <h6 class="form-subtitle">{{ $t("titles.player_tutor") }}</h6>

              <!-- NAME -->
              <div class="item">
                <label
                  >{{ $t("params.name") }} <span class="obligatory">*</span>
                </label>
                <input
                  type="text"
                  v-model="input.responsable_1_name"
                  class="upper"
                  :class="error.responsable_1_name ? 'input-error' : ''"
                  autocomplete="new-text"
                  disabled
                />
              </div>

              <!-- SURNAME -->
              <div class="item">
                <label>
                  {{ $t("params.surname") }} <span class="obligatory">*</span>
                </label>
                <input
                  type="text"
                  v-model="input.responsable_1_surname"
                  class="upper"
                  :class="error.responsable_1_surname ? 'input-error' : ''"
                  autocomplete="new-text"
                  disabled
                />
              </div>

              <!-- PHONE -->
              <div class="item">
                <label
                  >{{ $t("params.phone") }} <span class="obligatory">*</span>
                  <span v-if="error.invalit_phone2" class="obligatory">
                    {{ $t("errors.phone") }}</span
                  >
                </label>
                <vue-tel-input
                  v-model="input.responsable_1_phone"
                  @input="playerPhone2"
                  autocomplete="new-text"
                  style="border-color: transparent"
                  :placeholder="''"
                  :class="error.invalit_phone2 ? 'input-error' : ''"
                  defaultCountry="ES"
                  :inputOptions="{ showDialCode: true }"
                ></vue-tel-input>
              </div>

              <!-- DNI -->
              <div class="item">
                <label
                  >{{
                    $t("params.dni") +
                    " / " +
                    $t("params.nie") +
                    " / " +
                    $t("params.passport")
                  }}
                  <span class="obligatory">*</span>
                  <span
                    class="obligatory error"
                    v-if="error.responsable_1_invalit_dni"
                    >{{ " " + $t("errors.invalit_dni") }}</span
                  >
                  <span
                    class="obligatory error"
                    v-if="error.responsable_1_invalit_nie"
                    >{{ " " + $t("errors.invalit_nie") }}</span
                  >
                </label>
                <div>
                  <v-radio-group
                    v-model="input.responsable_1_document_type"
                    row
                    disabled
                  >
                    <v-radio :label="$t('params.dni')" value="1"></v-radio>
                    <v-radio :label="$t('params.nie')" value="2"></v-radio>
                    <v-radio :label="$t('params.passport')" value="3"></v-radio>
                  </v-radio-group>
                  <input
                    v-if="input.responsable_1_document_type == '1'"
                    :class="error.responsable_1_dni ? 'input-error' : ''"
                    type="text"
                    v-model="input.responsable_1_dni"
                    :placeholder="
                      $t('params.dni') + '  ' + $t('params.dni_format')
                    "
                    ref="dni"
                    class="upper"
                    autocomplete="new-text"
                    disabled
                  />
                  <input
                    v-if="input.responsable_1_document_type == '2'"
                    :class="error.responsable_1_dni ? 'input-error' : ''"
                    type="text"
                    v-model="input.responsable_1_dni"
                    :placeholder="
                      $t('params.nie') + '  ' + $t('params.nie_format')
                    "
                    ref="dni"
                    class="upper"
                    autocomplete="new-text"
                    disabled
                  />
                  <input
                    v-if="input.responsable_1_document_type == '3'"
                    :class="error.responsable_1_dni ? 'input-error' : ''"
                    type="text"
                    v-model="input.responsable_1_dni"
                    :placeholder="$t('params.passport')"
                    ref="dni"
                    class="upper"
                    autocomplete="new-text"
                    disabled
                  />
                </div>
              </div>
            </template>

            <h6 class="form-subtitle">{{ $t("titles.campus_info") }}</h6>

            <!-- CAMPUS -->
            <div class="item">
              <label>{{ $t("params.campus_programme") }}</label>
              <ul>
                <li v-for="campus in input.campus" :key="campus.id">
                  {{ $t(campus.type) }}: ( {{ campus.start_date }} -
                  {{ campus.end_date }} )
                </li>
              </ul>
            </div>

            <!-- MODALITY -->
            <div class="item" v-if="!is_virtual">
              <label>{{ $t("titles.modality") }} </label>
              <v-radio-group v-model="input.modality" row disabled>
                <v-radio value="1">
                  <template v-slot:label>
                    <span>{{ $t("intern") }}</span>
                  </template>
                </v-radio>
                <v-radio value="2">
                  <template v-slot:label>
                    <span>{{ $t("extern") }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>

            <!-- Bus -->
            <!-- <div class="item" v-if="event.type_id == 4">
              <label
                >{{ $t("descriptions.nike_bus") }}
                <span class="obligatory">*</span>
              </label>
              <v-radio-group v-model="input.bus" row>
                <v-radio value="1">
                  <template v-slot:label>
                    <span :class="error.bus ? 'obligatory' : ''">{{
                      $t("si")
                    }}</span>
                  </template>
                </v-radio>
                <v-radio value="2">
                  <template v-slot:label>
                    <span :class="error.bus ? 'obligatory' : ''">{{
                      $t("no")
                    }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div> -->

            <!-- (PGA) JOIN TO PGA -->
            <div class="item" v-if="input.join_campus != null">
              <label>{{ $t("params.join_campus") }}</label>
              <select v-model="input.join_campus" disabled>
                <option
                  v-for="(value, key) in joinCampus"
                  :value="key"
                  :key="key"
                >
                  {{ $t("campus." + value.name) }}
                </option>
              </select>
            </div>

            <ErrorPopup
              @close="closePopup()"
              @input="closePopup()"
              :dialog="dialog"
            ></ErrorPopup>

            <div class="actions">
              <div class="btn" id="cancel" @click="campus_home()">
                {{ $t("cancel") }}
              </div>
              <div class="btn" id="addedit" @click="validate()">
                {{ $t("update") }}
              </div>
            </div>
          </div>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
/* global moment, isEmpty */
import ErrorPopup from '@/components/ui/ErrorPopup.vue'
import Header from '@/components/layout/Header'

export default {
  name: 'CampusPersonEdit',
  components: {
    ErrorPopup,
    Header
  },
  data () {
    return {
      input: {
        id: '',
        name: '',
        surname: '',
        address: '',
        city: '',
        country_id: '',
        cp: '',
        state: '',
        nacionality: '',
        phone: '',
        phone2: '',
        mobile: '',
        email: '',
        dni: '',
        document_type: '',
        b_alergy: '',
        alergy: '',
        other_allergies: '',
        diet: '',
        birthday: '',
        gender: '',
        campus: '',
        modality: '',
        lottery: '',
        lottery_send: '',
        bus: '',
        club_name: '',
        shirt_size: '',
        join_campus: '',
        goalkeeper: '',
        b_medicamento: '',
        medicamento: '',
        swim: '',
        altura: '',
        language: '',
        b_news: '',
        how_meet: '',
        responsable_1_id: '',
        responsable_1_name: '',
        responsable_1_surname: '',
        responsable_1_dni: '',
        responsable_1_document_type: '',
        responsable_1_phone: '',
        responsable_1_original_phone: '',
        original_phone: '',
        original_mobile: ''
      },
      alergies: {},
      countries: {},
      campus_types: {},
      diets: {},
      how_meet: {},
      languages: {},
      shirt_sizes: {},
      joinCampus: {},
      dialog: false,
      dialog_birthday: false,
      error: {
        name: false,
        surname: false,
        dni: false,
        birthday: false,
        invalit_birthday: false,
        invalit_dni: false,
        invalit_nie: false,
        duplicated_dni: false,

        invalit_phone: false,
        invalit_phone2: false,
        invalit_mobile: false,

        responsable_1_name: false,
        responsable_1_surname: false,
        responsable_1_dni: false,
        responsable_1_invalit_dni: false,
        responsable_1_invalit_nie: false,
        responsable_1_invalit_phone: false,

        bus: false
      },
      bus_options: [
        { id: 1, name: 'campus.bus_type.go' },
        { id: 2, name: 'campus.bus_type.back' },
        { id: 3, name: 'campus.bus_type.both' }
      ],
      pickup_options: [
        { id: 1, name: 'campus.pickup.bcncenter' },
        { id: 2, name: 'campus.pickup.bcnsants' },
        { id: 3, name: 'campus.pickup.bcnairport' }
      ],
      is_virtual: false,
      doc_ok: false
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters.getCurrentEvent()
    },

    clothing_size_link () {
      let lang = this.user.language

      if (!['ca', 'es', 'en'].includes(lang)) {
        lang = 'ca'
      }

      let link = ''

      switch (lang) {
        case 'ca':
          link =
            'https://paugasolacademy.com/wp-content/uploads/2020/01/TALLES_PGA_2020_CAT.pdf'
          break
        case 'es':
          link =
            'https://paugasolacademy.com/wp-content/uploads/2020/01/TALLAS_PGA_2020_ESP.pdf'
          break
        case 'en':
          link =
            'https://paugasolacademy.com/wp-content/uploads/2020/01/TALLAS_PGA_2020_ENG.pdf'
          break
      }

      return link
    },

    lottery_link () {
      let lang = this.user.language

      if (!['ca', 'es', 'en'].includes(lang)) {
        lang = 'ca'
      }

      let link = ''

      if (this.user.event_name === 'Pau Gasol Academy') {
        switch (lang) {
          case 'ca':
            link =
              'https://paugasolacademy.com/wp-content/uploads/2020/01/RIFA-CAT-2020.pdf'
            break
          case 'es':
            link =
              'https://paugasolacademy.com/wp-content/uploads/2020/01/RIFA-ESP-2020.pdf'
            break
          case 'en':
            link =
              'https://paugasolacademy.com/wp-content/uploads/2020/01/RIFA-ENG-2020.pdf'
            break
        }
      } else if (this.user.event_name === 'MICCamp') {
        switch (lang) {
          case 'ca':
            link =
              'https://nikecamp.es/wp-content/uploads/2019/12/RIFA-CAT-2020.pdf'
            break
          case 'es':
            link =
              'https://nikecamp.es/wp-content/uploads/2019/12/RIFA-ESP-2020.pdf'
            break
          case 'en':
            link =
              'https://nikecamp.es/wp-content/uploads/2019/12/RIFA-ENG-2020.pdf'
            break
        }
      } else if (this.user.event_name === 'MICCamp BCN') {
        switch (lang) {
          case 'ca':
            link =
              'https://nikecamp.es/wp-content/uploads/2019/12/RIFA-CAT-2020.pdf'
            break
          case 'es':
            link =
              'https://nikecamp.es/wp-content/uploads/2019/12/RIFA-ESP-2020.pdf'
            break
          case 'en':
            link =
              'https://nikecamp.es/wp-content/uploads/2019/12/RIFA-ENG-2020.pdf'
            break
        }
      }

      return link
    }
  },
  created () {
    // save campus
    this.$store.commit('setCampus', true)

    // get player information
    var self = this

    this.$store
      .dispatch('person/loadPersonCampus', {
        campus_id: this.user.event_id,
        participant_id: this.user.participant_id
      })
      .then(function () {
        // save player information
        let person = self.$store.getters['person/getPerson']
        // save information
        self.input.name = person.name
        self.input.surname = person.surname
        self.input.address = person.address
        self.input.city = person.city
        self.input.country_id = person.country_id
        self.input.cp = person.cp
        self.input.state = person.state
        self.input.nacionality = person.nacionality
        self.input.phone = person.phone
        self.input.phone2 = person.phone2
        self.input.mobile = person.mobile
        self.input.email = person.email
        self.input.dni = person.dni
        self.input.document_type = person.document_type
        self.input.b_alergy = person.b_alergy
        self.input.alergy = person.alergy
        self.input.other_allergies = person.other_allergies
        self.input.diet = person.diet
        self.input.birthday = person.birthday
        self.input.parsedBirthday = moment(
          self.input.birthday,
          'YYYY-MM-DD'
        ).format('DD/MM/YYYY')
        self.input.gender = person.gender
        self.input.campus = person.campus
        self.input.modality = person.modality
        self.input.lottery = person.lottery === '1' ? 1 : 0
        self.input.lottery_send = person.lottery_send === '1' ? 1 : 0
        self.input.bus = person.bus ? person.bus : '0'
        self.input.pickup = person.pickup ? person.pickup : '0'
        self.input.returnit = person.returnit ? person.returnit : '0'
        self.input.transport_number = person.transport_number
        self.input.transport_from = person.transport_from
        self.input.club_name = person.club_name
        self.input.shirt_size = person.shirt_size
        self.input.join_campus = person.join_campus
        self.input.goalkeeper = person.goalkeeper
        self.input.b_medicamento = person.b_medicamento
        self.input.medicamento = person.medicamento
        self.input.swim = person.swim === '1' ? '1' : '0'
        self.input.altura = person.altura
        self.input.b_medicamento = person.b_medicamento
        self.input.medicamento = person.medicamento
        self.input.language = person.lang
        self.input.b_news = person.b_news
        self.input.how_meet = person.how_meet
        self.input.original_phone = person.phone
        self.input.original_mobile = person.mobil

        if (person.responsable_1 != null) {
          self.input.responsable_1_id = person.responsable_1.id
          self.input.responsable_1_name = person.responsable_1.name
          self.input.responsable_1_surname = person.responsable_1.surname
          self.input.responsable_1_dni = person.responsable_1.dni
          self.input.responsable_1_document_type =
            person.responsable_1.document_type
          self.input.responsable_1_phone = person.responsable_1.phone
          self.input.responsable_1_original_phone = person.responsable_1.phone
        }

        if (
          (!person.antithermal && [4, 5].includes(self.event.type_id)) ||
          !person.medicines ||
          !person.externals ||
          !person.image_right
        ) {
          self.doc_ok = false
        }

        // get countries and alergies
        self.$store
          .dispatch('getCampusInfo', { event_id: self.user.event_id })
          .then(function () {
            self.countries = self.$store.getters['getCountries']
            self.alergies = self.$store.getters['getAlergy']
            self.campus_types = JSON.parse(
              JSON.stringify(self.$store.getters['getCampusType'])
            )
            self.diets = self.$store.getters['getDiets']
            self.how_meet = self.$store.getters['getHowMeet']
            self.languages = self.$store.getters['getLanguages']
            self.shirt_sizes = self.$store.getters['getShirtSizes']
            self.joinCampus = self.$store.getters['getJoinCampus']

            // looop for each campus
            for (let i in self.input.campus) {
              // get campus
              let campus = self.campus_types[self.input.campus[i]]

              // format start and end date
              campus.start_date = moment(
                campus.start_date,
                'YYYY-MM-DD'
              ).format('DD/MM/YYYY')
              campus.end_date = moment(campus.end_date, 'YYYY-MM-DD').format(
                'DD/MM/YYYY'
              )

              // save campus information
              self.input.campus[i] = campus
              if (campus.type === 'campus.pga_virtual') self.is_virtual = true
            }
          })
      })
  },
  methods: {
    refresh () {
      this.$forceUpdate()
    },
    validate () {
      // validate
      let validate = true

      // // validate name
      // if(isEmpty(this.input.name)){
      //   this.error.name = true;
      //   validate = false;
      // } else {
      //   this.error.name = false;
      // }

      // // validate surname
      // if(isEmpty(this.input.surname)){
      //   this.error.surname = true;
      //   validate = false;
      // } else {
      //   this.error.surname = false;
      // }

      // validate dni
      // if(isEmpty(this.input.dni)){
      //   this.error.dni = true;
      //   validate = false;
      // } else {
      //   this.error.invalit_dni = false;
      //   this.error.invalit_nie = false;
      //   this.error.dni = false;
      //   // validate DNI
      //   if(this.input.document_type == 1){
      //     // invalit document
      //     if(!validateDocument(this.input.dni,1)){
      //       this.error.invalit_dni = true;
      //       this.error.dni = true;
      //       validate = false;
      //     // valit document
      //     } else {
      //       this.error.invalit_dni = false;
      //       this.error.dni = false;
      //     }
      //   }
      //   // validate NIE
      //   if(this.input.document_type == 2){
      //     if(!validateDocument(this.input.dni,2)){
      //       this.error.invalit_nie = true;
      //       this.error.dni = true;
      //       validate = false;
      //     // valit document
      //     } else {
      //       this.error.invalit_dni = false;
      //       this.error.dni = false;
      //     }
      //   }
      // }

      // validate birthday
      // if(isEmpty(this.input.birthday)){
      //   this.error.birthday = true;
      //   validate = false;
      // } else {

      //   // TODO check campus
      //   if(this.nikeValidateYear()){
      //     this.error.birthday = false;
      //     this.error.invalit_birthday = false;
      //   } else {
      //     validate = false;
      //   }

      // }

      // PHONE 1
      if (this.input.phone !== this.input.original_phone) {
        if (
          !isEmpty(this.input.phone) &&
          Object.keys(this.input.phone_aux).length > 0 &&
          this.input.phone_aux.isValid
        ) {
          this.input.phone = this.input.phone_aux.number.e164
          this.error.invalit_phone = false
        } else {
          this.error.invalit_phone = true
          validate = false
        }
      }

      // MOBILE
      if (!this.is_virtual && this.input.mobile !== this.input.original_mobile) {
        if (
          !isEmpty(this.input.mobile) &&
          Object.keys(this.input.mobile_aux).length > 0 &&
          this.input.mobile_aux.isValid
        ) {
          this.input.mobile = this.input.mobile_aux.number.e164
          this.error.invalit_mobile = false
        } else {
          this.error.invalit_mobile = true
          validate = false
        }
      }

      // PHONE RESPONABLE (PHONE 2)
      if (
        !this.is_virtual &&
        this.input.responsable_1_phone !==
          this.input.responsable_1_original_phone
      ) {
        if (
          !isEmpty(this.input.responsable_1_phone) &&
          Object.keys(this.input.phone2_aux).length > 0 &&
          this.input.phone2_aux.isValid
        ) {
          this.input.responsable_1_phone = this.input.phone2_aux.number.e164
          this.error.invalit_phone2 = false
        } else {
          this.error.invalit_phone2 = true
          validate = false
        }
      }

      if (!this.is_virtual && isEmpty(this.input.address)) { this.input.address = '' }
      if (!this.is_virtual && isEmpty(this.input.cp)) this.input.cp = ''
      if (!this.is_virtual && isEmpty(this.input.city)) this.input.city = ''
      if (isEmpty(this.input.state)) this.input.state = ''
      if (isEmpty(this.input.other_allergies) && !this.is_virtual) { this.input.other_allergies = '' }
      if (isEmpty(this.input.altura)) this.input.altura = ''
      if (isEmpty(this.input.club_name) && !this.is_virtual) { this.input.club_name = '' }
      if (isEmpty(this.input.medicamento) && !this.is_virtual) { this.input.medicamento = '' }
      if (isEmpty(this.input.altura)) this.input.altura = ''
      if (isEmpty(this.input.club_name) && !this.is_virtual) { this.input.club_name = '' }
      if (isEmpty(this.input.goalkeeper)) this.input.goalkeeper = ''
      this.input.lottery ? (this.input.lottery = 1) : (this.input.lottery = 0)
      if (isEmpty(this.input.shirt_size) && !this.is_virtual) { this.input.shirt_size = '' }
      if (isEmpty(this.input.join_campus) && !this.is_virtual) { this.input.join_campus = '' }

      if (validate) {
        var self = this

        // update player
        self.$store
          .dispatch('person/campusUpdatePlayer', {
            campus_id: self.user.event_id,
            participant_id: self.user.participant_id,
            input: self.input
          })
          .then(function () {
            self.campus_home()
          })
      } else {
        this.dialog = true
      }
    },

    formatBirthday () {
      this.input.parsedBirthday = moment(this.input.birthday).format(
        'DD/MM/YYYY'
      )
    },

    onlyNumber (evt) {
      if (!Number.isInteger(parseInt(evt.key))) {
        evt.preventDefault()
      }
    },

    playerPhone (input, oResult) {
      this.input.phone_aux = oResult
    },

    playerPhone2 (input, oResult) {
      this.input.phone2_aux = oResult
    },

    playerMobile (input, oResult) {
      this.input.mobile_aux = oResult
    },

    closePopup () {
      this.dialog = false
    },

    campus_home () {
      this.$router
        .push({
          name: 'campus_home',
          params: { campus_id: this.user.event_id }
        })
        .catch(() => {})
    },

    nikeValidateYear () {
      let validate = true

      let personBirthday = moment(this.input.birthday).format('DD/MM/YYYY')

      // loop for each campus
      for (let i in this.input.campus) {
        let campusFirstDate = moment(
          this.campus_types[this.input.campus[i]].start_date,
          'YYYY-MM-DD'
        ).format('DD/MM/YYYY')
        let campusLastDate = moment(
          this.campus_types[this.input.campus[i]].end_date,
          'YYYY-MM-DD'
        ).format('DD/MM/YYYY')

        // validate for 8 first day of the campus
        // validate for 17 years last day of the campus

        // (year) 8 years - 18 years
        if (
          moment(campusFirstDate, 'DD/MM/YYYY').year() -
            moment(personBirthday, 'DD/MM/YYYY').year() >=
            8 &&
          moment(campusLastDate, 'DD/MM/YYYY').year() -
            moment(personBirthday, 'DD/MM/YYYY').year() <=
            18
        ) {
          // validate month and day if result is exact 8 years (players need to have 8 years the first day of the campus)
          if (
            moment(campusFirstDate, 'DD/MM/YYYY').year() -
              +moment(personBirthday, 'DD/MM/YYYY').year() ===
            8
          ) {
            // validate month
            // same campus month, validate day
            if (
              moment(campusFirstDate, 'DD/MM/YYYY').month() +
                1 -
                +(moment(personBirthday, 'DD/MM/YYYY').month() + 1) ===
              0
            ) {
              // day bigger than campus, error
              if (
                moment(campusFirstDate, 'DD/MM/YYYY').date() -
                  moment(personBirthday, 'DD/MM/YYYY').date() <
                0
              ) {
                this.error.birthday = true
                this.error.invalit_birthday = true
                validate = false
              }

              // month bigger than campus, invalit
            } else if (
              moment(campusFirstDate, 'DD/MM/YYYY').month() -
                moment(personBirthday, 'DD/MM/YYYY').month() <
              0
            ) {
              this.error.birthday = true
              this.error.invalit_birthday = true
              validate = false
            }
          }

          // validate month and day if result is exact 18 years (players need to have 17 years the last day of the campus)
          if (
            moment(campusLastDate, 'DD/MM/YYYY').year() -
              +moment(personBirthday, 'DD/MM/YYYY').year() ===
            18
          ) {
            // validate first day from campus (MONTH)
            if (
              moment(campusFirstDate, 'DD/MM/YYYY').month() +
                1 -
                (moment(personBirthday, 'DD/MM/YYYY').month() + 1) >
              0
            ) {
              this.error.birthday = true
              this.error.invalit_birthday = true
              validate = false
            }

            // validate first day from campus (DAY)
            if (
              moment(campusFirstDate, 'DD/MM/YYYY').month() +
                1 -
                +(moment(personBirthday, 'DD/MM/YYYY').month() + 1) ===
              0
            ) {
              // validate peron day with the first day of the campus
              if (
                moment(campusFirstDate, 'DD/MM/YYYY').date() -
                  moment(personBirthday, 'DD/MM/YYYY').date() >=
                0
              ) {
                this.error.birthday = true
                this.error.invalit_birthday = true
                validate = false
              }
            }

            // validate month
            if (
              moment(campusLastDate, 'DD/MM/YYYY').month() +
                1 -
                +(moment(personBirthday, 'DD/MM/YYYY').month() + 1) ===
              0
            ) {
              // day bigger than campus, error
              if (
                moment(campusLastDate, 'DD/MM/YYYY').date() -
                  moment(personBirthday, 'DD/MM/YYYY').date() >=
                0
              ) {
                this.error.birthday = true
                this.error.invalit_birthday = true
                validate = false
              }
            }

            if (
              moment(campusLastDate, 'DD/MM/YYYY').month() +
                1 -
                (moment(personBirthday, 'DD/MM/YYYY').month() + 1) <
              0
            ) {
              this.error.birthday = true
              this.error.invalit_birthday = true
              validate = false
            }
          }

          // person is bigger than 17 years or smaller than 8 years
        } else {
          this.error.birthday = true
          this.error.invalit_birthday = true
          validate = false
        }
      }

      return validate
    },

    removeAlergy (item) {
      let index = this.input.alergy.indexOf(item.id)
      if (index >= 0) {
        let aux = JSON.parse(JSON.stringify(this.input.alergy))
        aux.splice(index, 1)
        this.input.alergy = aux
      }
    }
  },
  watch: {
    'input.parsedBirthday': function () {
      if (moment(this.input.parsedBirthday, 'DD/MM/YYYY').isValid()) {
        this.input.birthday = moment(
          this.input.parsedBirthday,
          'DD/MM/YYYY'
        ).format('YYYY-MM-DD')
      }
    }
  },
  mounted () {}
}
</script>

<style lang="scss" src="@/styles/_person_edit.scss">
/* you can leave this empty or add component-specific overrides */
</style>

<style lang="scss" scoped>
.actions {
  padding: 25px;
  margin: 0 auto;
  margin-bottom: 25px;
  text-align: center;

  .btn {
    width: calc(50% - 20px);
    margin: 0 10px;
    display: inline-block;
    min-width: 40px;
    padding: 0 35px;
    outline: none;
    border: none;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    border-radius: 3px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    background-color: #172654;
    color: #fff;
    height: 40px;
    line-height: 40px;
    text-transform: uppercase;
    background-color: #fc8926;
    font-family: AvantGarde-Bold;
    max-width: 300px;
    transition: background-color 0.5s ease;

    &#addedit {
      border: 1px solid #fc8926;

      &:hover {
        background-color: #e78026;
        border-color: #e78026;
      }
    }

    &#cancel {
      background-color: transparent;
      color: #c55c00;
      border: 1px solid #fc8926;

      &:hover {
        background-color: #fc8a2623 !important;
      }
    }
  }
}

@include media("<=desktop") {
  .actions {
    padding: 25px 0px;

    .btn {
      padding: 0 15px;
    }
  }
}
</style>
